/**
 * Created by mac on 10/6/20
 */

const AdminLevelMaxiature = {
    generate: function (adminLevel, options) {
        options = options || {};
        const MaxiatureGenerator = AdminLevelMaxiature[cleverapps.config.name] || AdminLevelMaxiature[cleverapps.config.type];
        if (adminLevel !== undefined && MaxiatureGenerator) {
            try {
                cleverapps.environment.setLevel(adminLevel.levelNo);
                cleverapps.environment.setEpisode(adminLevel.episodeNo);
                return MaxiatureGenerator(adminLevel, options);
            } catch (e) {
                console.log(`Error in level maxiature ${cleverapps.humanReadableNumber(adminLevel.episodeNo, adminLevel.levelNo)}`, e);
            }
        }

        return AdminLevelMaxiature.default();
    },

    bundles: {
        match3: function () {
            return ["enemies"];
        }
    },

    default: function () {
        return new cc.Sprite(bundles.admin.frames.loading_png);
    },

    merge: function (adminLevel) {
        const locationConfig = cleverapps.meta.getLocationMeta(adminLevel.location).locationConfig;

        const bundle = bundles[locationConfig.locationBundleId];

        const merge = new FakeMerge(adminLevel);

        const slot = cleverapps.dataSlots.getSlot("fake");

        const map = merge.map = new Map2d(slot, adminLevel.content.map, {
            units: bundle.meta.units,
            tiles: bundle.meta.tiles,
            visibleBox: adminLevel.content.visibleBox,
            terrains: adminLevel.content.terrains,
            field: adminLevel.content.field,
            background: adminLevel.content.background,
            waterBorder: 0
        });

        Map2d.InsertDefaults(map, adminLevel.content.field);

        const SIZE = map.getWidth() + map.getHeight();
        const totalWidth = SIZE * cleverapps.styles.Map2dView.cell.width / 2;
        const totalHeight = SIZE * cleverapps.styles.Map2dView.cell.height / 2;

        const context = {
            level: new Level(adminLevel.episodeNo, adminLevel.levelNo)
        };
        const bundles = GameSceneComponent.prototype.listBundles.call(context);

        const preview = new AdminLevelPreview(bundles, ((preview) => {
            const view = new Map2dInnerView(map);
            view.setAlignment({ align: "center" }, { align: "center" });
            view.setScale(Math.min(preview.width / view.width, preview.height / view.height));
            preview.addChild(view);
            view.removeFromParent();
            preview.addChild(view);
            view.setVisibleRect(cc.rect(0, 0, view.width, view.height));
        }));
        preview.setContentSize(totalWidth, totalHeight);

        return preview;
    },

    tileGame: function (adminLevel) {
        const styles = cleverapps.styles.AdminLevelMaxiature.tiles;
        let wrapper;
        let mainScreen;
        let subScreensLayout;
        let selected = 0;
        let orientation = cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL ? TileTable.ORIENTATION_HORIZONTAL : TileTable.ORIENTATION_VERTICAL;
        let changeOrientationButton;
        const wrap = function (content) {
            wrapper = new cc.Node();
            wrapper.setContentSize2(styles);
            wrapper.addChild(content);
            content.setAlignment(wrapper.width / 2, wrapper.height / 2);
            cleverapps.UI.fitToBox(content, wrapper.getContentSize());
            if (cleverapps.config.type === "solitaire") {
                changeOrientationButton = createChangeOrientationButton();
                changeOrientationButton.setAlignment(styles.button);
                wrapper.addChild(changeOrientationButton);
            }
            return wrapper;
        };

        const toMiniature = function (screen, orientation) {
            const nextScreenLevel = AdminLevel.createFromData({}, adminLevel.getContent());
            nextScreenLevel.screens = [screen];
            return AdminLevelMiniature.tileGame(nextScreenLevel, orientation);
        };

        const createMainScreen = function (screen, orientation) {
            mainScreen = toMiniature(screen, orientation);
            mainScreen.setAnchorPoint(0.5, 0.5);
            cleverapps.UI.fitToBox(mainScreen, styles.mainScreen);
        };

        const createChangeOrientationButton = function () {
            const styles = cleverapps.styles.AdminDetailControls;

            const icon = new cc.Sprite(bundles.admin.frames.change_orientation);
            const button = new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.editor,
                content: icon,
                width: styles.width,
                height: styles.height,
                onClicked: function () {
                    orientation ^= 1;
                    changeMainScreen(adminLevel.screens[selected], orientation);
                }
            });
            button.setVisible(adminLevel.screens[0].horizontalCards && adminLevel.screens[0].cards);

            return button;
        };

        const changeMainScreen = function (screen, horizontal) {
            changeOrientationButton && changeOrientationButton.setVisible(screen.horizontalCards && screen.cards);
            const oldScreen = mainScreen;
            createMainScreen(screen, horizontal);
            const parentLayout = oldScreen.parent;
            oldScreen.removeFromParent();
            const items = [mainScreen].concat(parentLayout.children);
            parentLayout.setItems(items, false);
            cleverapps.UI.fitToBox(parentLayout, styles);
        };

        if (adminLevel.screens.length > 1) {
            const select = function (newSelected) {
                if (newSelected === selected) {
                    return;
                }
                small.forEach((tileWithCaption, index) => {
                    tileWithCaption.tile.setSpriteFrame(index === newSelected ? bundles.admin.frames.lvl_selected_bg : bundles.admin.frames.lvl_bg);
                });
                changeMainScreen(adminLevel.screens[newSelected]);
                selected = newSelected;
            };

            const subScreens = [];
            adminLevel.screens.forEach((screen) => {
                subScreens.push(toMiniature(screen));
            });
            const small = [];
            for (let i = 0; i < subScreens.length; i++) {
                const bgImage = i === 0 ? bundles.admin.frames.lvl_selected_bg : bundles.admin.frames.lvl_bg;
                const bg = cleverapps.UI.createScale9Sprite(bgImage, cleverapps.UI.Scale9Rect.TwoPixelXY);
                bg.setContentSize2(styles.subScreens.bg);

                const text = cleverapps.UI.generateImageText(i + 1, cleverapps.styles.FONTS.ADMIN_LEVEL_TEXT);
                text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

                cleverapps.UI.fitToBox(subScreens[i], styles.subScreens);
                subScreens[i].setAlignment(styles.subScreens);
                bg.addChild(subScreens[i]);

                const tileWithCaption = new cleverapps.Layout([bg, text], {
                    direction: cleverapps.UI.VERTICAL,
                    margin: styles.margins.vertical
                });
                tileWithCaption.tile = bg;

                small.push(tileWithCaption);

                cleverapps.UI.onClick(tileWithCaption, select.bind(this, i));
                cleverapps.UI.applyHover(tileWithCaption);

                subScreensLayout = new cleverapps.Layout(small, {
                    direction: cleverapps.UI.HORIZONTAL,
                    margin: styles.margins.horizontal
                });
            }
        }

        createMainScreen(adminLevel.screens[selected]);

        const layout = new cleverapps.Layout([mainScreen, subScreensLayout], {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.AdminLevelMaxiature.tiles.margins.vertical
        });

        return wrap(layout);
    },

    scramble: function (adminLevel) {
        const words = adminLevel.words;

        const game = new FakeGame(adminLevel);
        const bgImage = new GameSceneComponent({ args: [{ level: game.level }] }).styling.bgImage;

        const mapWord = function (word, index) {
            const layout = new cleverapps.Layout(word.split("").map((symbol) => {
                const bg = new cc.Sprite(bgImage);
                const char = CharView.Create(symbol, { noBg: true });
                char.setAlignment(bg.width / 2, bg.height / 2);
                bg.addChild(char);
                return bg;
            }), {
                direction: cleverapps.UI.HORIZONTAL,
                margin: cleverapps.styles.AdminLevelMaxiature.scramble.margin.x
            });

            layout.setLocalZOrder(-index);

            return layout;
        };

        const box = new cc.Node();
        if (adminLevel.hint) {
            const hint = cleverapps.UI.generateOnlyText(adminLevel.hint, cleverapps.styles.FONTS.MAXIATURE_LABEL);
            box.addChild(hint);
            box.setContentSize2(hint.width, hint.height * 1.5);
            box.setAnchorPoint(0.5, 0.5);
            hint.setAlignment({ align: "center" }, { align: "top" });
        }

        return new cleverapps.Layout([box].concat(words.map(mapWord)), {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.AdminLevelMaxiature.scramble.margin.y
        });
    },

    differences: function (adminLevel, options) {
        const placeholder = new cc.Node();
        placeholder.setContentSize2(cleverapps.styles.AdminLevelMaxiature.bg);
        placeholder.setAnchorPoint(0.5, 0.5);

        const loading = new cc.Sprite(bundles.admin.frames.loading_png);
        placeholder.addChild(loading);
        loading.setAlignment(placeholder.width / 2, placeholder.height / 2);

        const game = new FakeGame(adminLevel);
        const name = game.level.getImageBundle();
        if (bundles[name]) {
            cleverapps.bundleLoader.loadBundle(name, {
                onSuccess: function () {
                    const images = [new cc.Sprite(bundles[name].urls.a), new cc.Sprite(bundles[name].urls.b)];

                    adminLevel.differences.forEach((area, id) => {
                        images.forEach((image) => {
                            const frame = cleverapps.UI.createScale9Sprite(bundles.admin.frames.area_selection, cleverapps.UI.Scale9Rect.TwoPixelXY);
                            image.addChild(frame);

                            const frameInfo = PhotoViews.FrameSizeAndPos(new DifferenceArea(area));

                            frame.setContentSize(frameInfo);
                            frame.setAlignment(frameInfo);

                            const bg = new cc.Sprite(bundles.admin.frames.number_bg);
                            bg.setAlignment(frame.x - frame.width / 2, frame.y + frame.height / 2);
                            bg.x += cleverapps.styles.AdminLevelMaxiature.label.offsetX;
                            bg.y += cleverapps.styles.AdminLevelMaxiature.label.offsetY;
                            frame.parent.addChild(bg);

                            const label = cleverapps.UI.generateImageText(`${id + 1}`, cleverapps.styles.FONTS.MAXIATURE_LABEL);
                            label.setAlignment(bg.width / 2, bg.height / 2);
                            bg.addChild(label);
                        });
                    });

                    const layout = new cleverapps.Layout(images, {
                        direction: cleverapps.UI.VERTICAL,
                        reversed: true,
                        margin: cleverapps.styles.AdminLevelMaxiature.tiles.margins.vertical
                    });

                    if (!options.enlarge) {
                        cleverapps.UI.fitToBox(layout, cleverapps.styles.AdminLevelMaxiature.bg);
                    }
                    placeholder.addChild(layout);
                    layout.setAlignment(placeholder.width / 2, placeholder.height / 2);

                    loading.removeFromParent();
                }
            });
        }

        return placeholder;
    },

    battlefield: function (adminLevel) {
        return AdminLevelMiniature.battlefield(adminLevel);
    },

    board: function (adminLevel) {
        let words = `Base: ${adminLevel.base}\n\n`;

        words += adminLevel.words.map((word, id) => {
            let text = `${id + 1}. ${word}`;
            if (adminLevel.definitions) {
                text += ` - ${adminLevel.definitions[word]}`;
            }
            return text;
        }).join("\n");

        return cleverapps.UI.generateOnlyText(words, cleverapps.styles.FONTS.ADMIN_DATA_TEXT);
        // var game = new FakeGame(adminLevel);
        // var boardView = new cleverapps.BoardView(game.board);
        //
        // return boardView;
    },

    match3: function (adminLevel) {
        const styles = cleverapps.styles.AdminLevelMaxiature;

        const view = AdminLevelMiniature.match3(adminLevel);

        const goalsView = new GoalsView();

        goalsView.rotation = 0;
        goalsView.views.forEach((goalView) => {
            goalView.rotation = 0;
        });

        const movesView = new MovesView();
        cleverapps.UI.wrap(movesView);

        let maxWidth = movesView.width + goalsView.width + goalsView.width / 2 + styles.match3.movesView.offsetX;
        if (maxWidth < view.width) {
            maxWidth = view.width;
        }

        const goalsAndMovesBg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        goalsAndMovesBg.setContentSize(maxWidth + styles.match3.bgPadding, goalsView.height + styles.match3.bgPadding);
        goalsAndMovesBg.addChild(goalsView);
        goalsView.setAlignment(goalsAndMovesBg.width / 2, goalsAndMovesBg.height / 2);
        goalsAndMovesBg.addChild(movesView);
        movesView.setAlignment(goalsView.x - goalsView.width / 2 - movesView.width / 2 - styles.match3.movesView.offsetX, goalsView.y);

        const fieldBg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        fieldBg.setContentSize(maxWidth + styles.match3.bgPadding, view.height + styles.match3.bgPadding);
        fieldBg.addChild(view);
        view.setAlignment(fieldBg.width / 2, fieldBg.height / 2);

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.addChild(goalsAndMovesBg);
        content.addChild(fieldBg);
        goalsAndMovesBg.setPosition(fieldBg.x, fieldBg.y + fieldBg.height / 2 + goalsAndMovesBg.height / 2 + styles.match3.margin);

        cleverapps.UI.wrap(content);

        goalsView.onResize = function () {};
        if (goalsView.bgTitle) {
            goalsView.bgTitle.onResize = function () {};
        }
        if (goalsView.background) {
            goalsView.background.onResize = function () {};
        }
        movesView.onResize = function () {};

        return content;
    },

    blocks: function (adminLevel) {
        const grid = new Grid(adminLevel.content);
        const goals = new Goals(adminLevel);

        const gridView = this.gridView = new GridView(grid);
        gridView.pointHandler.remove();
        const goalsView = new GoalsView(goals);
        goalsView.show(true);

        const gridLayout = this.gridLayout = new cleverapps.Layout([goalsView, gridView], {
            direction: cleverapps.resolution.mode !== cleverapps.WideMode.HORIZONTAL ? cleverapps.UI.VERTICAL : cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.BlocksGameScene.margin
        });

        return cleverapps.UI.wrap(gridLayout);
    }
};

AdminLevelMaxiature.tile3 = AdminLevelMaxiature.solitaire = AdminLevelMaxiature.tileGame;

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MAXIATURE_LABEL: {
        name: "formal",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_BROWN
    }
});

cleverapps.styles.AdminLevelMaxiature = {
    bg: {
        width: 500,
        height: 670
    },

    scramble: {
        offset: {
            x: { align: "left", dx: 100 },
            y: { align: "top", dy: -100 }
        },
        margin: {
            x: -10,
            y: -30
        }
    },

    tiles: {
        width: 700,
        height: 700,
        margins: {
            vertical: 20,
            horizontal: 26
        },
        mainScreen: {
            width: 600,
            height: 800
        },
        subScreens: {
            width: 150,
            height: 200,
            x: { align: "center" },
            y: { align: "center" },
            bg: {
                width: 160,
                height: 210
            }
        },
        button: {
            x: { align: "right" },
            y: { align: "bottom" }
        }
    },

    label: {
        offsetX: 10,
        offsetY: -10
    },

    match3: {
        bgPadding: 60,
        margin: 20,
        movesView: {
            offsetX: 50
        }
    }
};